import { FlatTreeControl } from '@angular/cdk/tree';
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material';

@Component({
  selector: 'ze-tree-table',
  templateUrl: './tree-table.component.html',
  styleUrls: ['./tree-table.component.scss']
})
export class TreeTableComponent implements OnInit, OnChanges {
  @Input() treeData: any[];
  @Input() showHeader: boolean = true;
  @Input() displayedColumns: string[];
  @Input() transformer: (node: any, level: number) => any;

  treeControl: any;
  treeFlattener: any;
  dataSource: any;

  constructor() {
  }

  ngOnInit(): void {
    this.treeControl = new FlatTreeControl<any>(
      node => node.level, node => node.expandable);

    this.treeFlattener = new MatTreeFlattener(
      this.transformer, node => node.level, 
      node => node.expandable, node => node.departments);

    this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
    this.dataSource.data = this.treeData;
    if(this.treeControl.dataNodes[0].expandable == true) {
      this.treeControl.toggle(this.treeControl.dataNodes[0]);
    }
  }

  ngOnChanges(): void {
    this.refreshTree();
  }

  findNodeById(root: any[], targetId: string, subTree: string): any | null {
    for (const node of root) {
      if (node.id === targetId) {
        return node; // Found the node with the specified ID
      }
  
      if (node.departments) {
        const foundInChildren = this.findNodeById(node[subTree], targetId, subTree);
        if (foundInChildren) {
          return foundInChildren; // Node found in children
        }
      }
    }
  
    return null; // Node with specified ID not found
  }
  
  refreshNode(newNodeData: any, subTree: string) {
    let refreshingNode = this.findNodeById(this.treeData, newNodeData.id, subTree);
    refreshingNode = newNodeData;
    this.refreshTree();
    this.treeControl.dataNodes.forEach(dataNode => {
      if(dataNode.id == newNodeData.id && dataNode.expandable) {
        this.treeControl.expand(dataNode);
      }
    });
  }

  refreshTree() {
    if(this.transformer != null && this.treeControl != undefined) {
      const expandedNodes = this.treeControl.expansionModel.selected;
      this.dataSource.data = this.treeData;
      this.treeControl.collapseAll();
      expandedNodes.forEach((node) => {
        this.treeControl.dataNodes.forEach(dataNode => {
          if(dataNode.id == node.id) {
            this.treeControl.expand(dataNode);
          }
        });
      });
    }
  }

  hasChild = (_: number, node: any) => node.expandable;

}